import { useLocation, useParams } from 'react-router-dom';
import styles from './SearchResultsPage.module.scss';
import { useEffect, useState } from 'react';
import { getFixcenterSearchedProducts } from '../../services/products.service';
import { ISearchProductDetails } from '../../shared/models/searched-products-details.interface';
import ProductsSkeletonGrid from '../../components/second-level-product-card/product-skeleton/product-skeleton';
import { ISearchFilter } from '../../shared/models/searched-products-filters.interface';
import SearchCategory from './SearchCategory';

export default function SearchResultsPage() {
    const { value } = useParams();
    const [data, setData] = useState<ISearchProductDetails[]>([]);
    const [filter, setFilter] = useState<ISearchFilter>();
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const fetchSearch = async (searchFilter: ISearchFilter) => {
        setLoading(true);
        const lang = localStorage.getItem("lang") || "en";
        setFilter(searchFilter);
        try {
            if (value !== undefined) {
                searchFilter.languageCode = lang;
                const response = await getFixcenterSearchedProducts(searchFilter);
                const spds: ISearchProductDetails[] = response.data;
                if (spds) {
                    if (spds.length == 1) {
                        window.location.href = `${window.location.origin}/${lang}/webshop/product/${spds[0].mainCategoryName}/${spds[0].parentCategoryUuid}/${spds[0].categoryUuid}`;
                    } else if (spds.length == 0) {
                        window.location.href = `${window.location.origin}/${lang}/search/not-found`;
                    } else {
                        setData(spds);
                        setLoading(false);
                    }
                } else {
                    window.location.href = `${window.location.origin}/${lang}/search/not-found`;
                }
            }
        } catch {
            window.location.href = `${window.location.origin}/${lang}/search/not-found`;
        }
    };

    useEffect(() => {
        if (value) {
            const search: ISearchFilter = {
                name: decodeURIComponent(value),
                page: 1
            }
            fetchSearch(search);
        }
    }, [value, location.pathname]);
    return (
        <div className={styles.container}>
            {loading ? <ProductsSkeletonGrid count={20} /> : <SearchCategory categories={data} filter={filter as ISearchFilter} />}
        </div>
    )
}